/* 
    DEV NOTES:
    .MuiAutocomple-popper is styled in the index.css
*/


import { Autocomplete, TextField } from "@mui/material"
import { commonStyling } from "./common";

interface ComboBoxProps {
    options: object[];
    inputPlaceholder?: string;
}



function ComboBox(props: ComboBoxProps) {
    return (
        <Autocomplete
            renderInput={(params: any) => <TextField {...params} label="" placeholder={`${props.inputPlaceholder ?? ''}`} />}
            className={'!transition-none min-w-[300px] w-full'}
            sx={
                {
                    ...commonStyling,
                }
            }
            {...props}
        />
    )
}

export default ComboBox